<template>
	<v-dialog
		v-model="dialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				color=" secondary"
				class="ml-2"
				:disabled="!selectedInfos.length"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-check-circle-outline</v-icon>
				製造オーダーを発行する
			</v-btn>
		</template>

		<v-card flat>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">製造オーダー発行</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="closeDialog()" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<div class="mt-4 pa-2">
				選択された製造番号の製造オーダーを発行します。<br />
				本当に発行しますか。
			</div>
			<div class="mt-4 pa-2">
				<h6 class="text-body-1 font-weight-bold">選択製番</h6>
				<p v-for="(orderIndividualInfo, i) in selectedInfos" :key="i">
					{{ common.productNameWithProductNumber(orderIndividualInfo) }}
				</p>
			</div>
			<v-card-actions>
				<v-row no-gutters justify="center">
					<v-btn class="mt-4 mr-4" color="secondary" dark @click="issueManufactureOrder()">
						<v-icon class="mr-1">mdi-check-circle-outline</v-icon>
						製造オーダーを発行する</v-btn
					>
					<v-btn class="mt-4 ml-4" @click="closeDialog()">キャンセル</v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import common from "../../../helper/common"

export default {
	props: {
		selectedInfos: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			dialog: false,
			common,
		}
	},
	methods: {
		issueManufactureOrder() {
			this.$emit("issue-manufacture-orders")
			this.closeDialog()
		},
		closeDialog() {
			this.dialog = false
		},
	},
}
</script>
